<div class="button-bar-container">
  <div class="content-container">
    <div [class.service-name-wrapper]="totalSelectedServices > 0">
      <ng-container *ngIf="selectedDate">
        <h2 class="price-label">
          {{ selectedDate | dateFormatter }}
          {{ selectedDate | timeFormatter : true }}
        </h2>
      </ng-container>

      <ng-container *ngIf="totalSelectedServices > 0; else selectServiceHint">
        <div class="service-name-wrapper">
          {{ nameOfSelectedService }}
        </div>
        <div *ngIf="!selectedDate">
          {{ 'button-bar-for-selected-service.text.duration' | translate }}:
          {{ totalDuration * 60 | durationFormatter }}
        </div>
      </ng-container>

      <ng-template #selectServiceHint>
        <span class="hint-text">{{
          customHintText ||
            'button-bar-for-selected-service.text.select-service-hint'
            | translate
        }}</span>
      </ng-template>
    </div>

    <div class="flex-row-space-between">
      <ng-container *ngIf="totalSelectedServices > 0">
        <div class="total-price-wrapper">
          <div
            *ngIf="isAnySelectedServiceInDiscount"
            class="original-price-label"
          >
            {{ totalPrice | roundNumberFormatter }}
            {{ businessObject?.currency }}
          </div>
          <div class="price-label">
            {{
              (isAnySelectedServiceInDiscount
                ? totalDiscountedPrice
                : totalPrice
              ) | roundNumberFormatter
            }}
            {{ businessObject?.currency }}
          </div>
        </div>
      </ng-container>

      <button
        mat-flat-button
        color="primary"
        class="submit-button"
        [disabled]="isDisabledButton"
        (click)="buttonClicked.emit()"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
